import { connect } from 'react-redux';

import UserDetailView from './UserDetailView.jsx';
import { showSettingsSideMenu, hideSettingsSideMenu } from 'src/legacy/redux/actions/settings.jsx';
import { invalidateUser, updateUserActivation, updateUserAccess, resendInvitation, 
  deleteInvitation, fetchAccountUsers, assignUserRole, invalidateAccountUsers, fetchUserManagementList, fetchUserGroupsForUser} from 'src/legacy/redux/actions/userManagement.jsx';
import { fetchUserRolesForAccount } from 'src/legacy/redux/actions/userRoles.jsx'
import hasAccess from 'src/legacy/services/hasAccess.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    inviting: state.legacyRootReducer.settings.userManagement.invitations.resending,
    deleting: state.legacyRootReducer.settings.userManagement.invitations.deleting,
    user: state.legacyRootReducer.settings.userManagement.users.user,
    invitation: state.legacyRootReducer.settings.userManagement.invitations.invitation,
    updatingAccess: state.legacyRootReducer.settings.userManagement.users.updatingAccess,
    updating: state.legacyRootReducer.settings.userManagement.users.updating,
    account: state.accounts.item,
    userRoles: _.get(state, "legacyRootReducer.userRoles.items", []),
    starterRole: _.get(state, "legacyRootReducer.settings.userManagement.users.user.starterRole", false),
    showManageRoles: _.get(state, "accounts.item.manageRoles", false),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      dispatch(showSettingsSideMenu());
    },

    hideSettingsSideMenu: () => {
        dispatch(hideSettingsSideMenu());
    },

    updateUserActivation: (user) => {
       return dispatch(updateUserActivation(user));
    },

    updateUserAccess: (user) => {
      return dispatch(updateUserAccess(user));
    },

    resendInvitation: (id) => {
      return dispatch(resendInvitation(id));
    },

    deleteInvitation: (id) => {
      return dispatch(deleteInvitation(id));
    },

    invalidateUser: () => {
      dispatch(invalidateUser());
    },

    fetchAccountUsers: (page, query) => {
      dispatch(fetchAccountUsers(page, query));
    },
    invalidateAccountUsers: () => {
      return dispatch(invalidateAccountUsers());
    },
    fetchUserRolesForAccount: () => {
      dispatch(fetchUserRolesForAccount());
    },
    assignUserRole: (user) => {
      return dispatch(assignUserRole(user));
    },
    fetchUserManagementList: (page, query, filter) => {
      dispatch(fetchUserManagementList(page, query, filter))
    },
    fetchUserGroupsForUser: (page, user) => {
      dispatch(fetchUserGroupsForUser(page, user))
    }
  }
}

const UserDetailContainer = connect (
  mapStateToProps,
  mapDispatchToProps
)(UserDetailView);

// export default hasAccess(UserDetailContainer, 'user-management');
export default withUseHooks(UserDetailContainer);